import { createContext, useState, useEffect } from "react";
import { removeLocalStorage } from "../utils/helper";
import apiClient from "../../src/utils/api";
import { userInfo } from "../../src/utils/appInfo";

export const UserContext = createContext({
  updateUserData: () => {},
  userLogout: () => {},
  userLogin: () => {},
  userData: "",
});

const UserContextProvider = ({ children }) => {
  const initialValue = {
    name: "",
    email: "",
    isLoggedin: false,
    cart: [],
  };
  const [userData, setUserData] = useState(initialValue);

  const updateUserData = (data) => {
    setUserData((prev) => {
      return { ...prev, ...data };
    });
  };
  useEffect(() => {
    const fetchCart = async () => {
      try {
        const { data: cData = [] } = await apiClient.post("get/cart.php", {
          user_id: userInfo().email,
        });
        updateUserData({ cart: cData });
      } catch (error) {
        updateUserData({ cart: [] });
      }
    };

    if (userInfo()?.email) {
      fetchCart();
    }
  }, []);

  const userLogin = () => {};

  const userLogout = () => {
    removeLocalStorage("uid");
    removeLocalStorage("userInfo");
    setUserData(initialValue);
  };

  return (
    <UserContext.Provider
      value={{ updateUserData, userData, userLogout, userLogin }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
